import Vue from 'vue';

/* Icons */
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fas);

Vue.component('app-icon', FontAwesomeIcon);

import Table from '@/components/table/Wrapper';
import TableHeader from '@/components/table/Header';
import TableFooter from '@/components/table/Footer';
import TableBody from '@/components/table/Body';
import TableRow from '@/components/table/Row';
import TableCell from '@/components/table/Cell';

Vue.component('app-table', Table);
Vue.component('app-table-header', TableHeader);
Vue.component('app-table-footer', TableFooter);
Vue.component('app-table-body', TableBody);
Vue.component('app-table-row', TableRow);
Vue.component('app-table-cell', TableCell);

/* Composer Elements */

Vue.component('arrowed-link-settings', require('@/components/composer/Elements/ArrowedLinkSettings.vue').default);
Vue.component('ask-a-question-settings', require('@/components/composer/Elements/AskAQuestionSettings.vue').default);
Vue.component('banner-one-settings', require('@/components/composer/Elements/BannerOneSettings.vue').default);
Vue.component('banner-two-settings', require('@/components/composer/Elements/BannerTwoSettings.vue').default);
Vue.component('banner-three-settings', require('@/components/composer/Elements/BannerThreeSettings.vue').default);
Vue.component('banner-four-settings', require('@/components/composer/Elements/BannerFourSettings.vue').default);
Vue.component('banner-five-settings', require('@/components/composer/Elements/BannerFiveSettings.vue').default);
Vue.component('banner-six-settings', require('@/components/composer/Elements/BannerSixSettings.vue').default);
Vue.component('banner-seven-settings', require('@/components/composer/Elements/BannerSevenSettings.vue').default);
Vue.component('banner-eight-settings', require('@/components/composer/Elements/BannerEightSettings.vue').default);
Vue.component('banner-nine-settings', require('@/components/composer/Elements/BannerNineSettings.vue').default);
Vue.component('breadcrumbs-settings', require('@/components/composer/Elements/BreadcrumbSettings.vue').default);
Vue.component('button-settings', require('@/components/composer/Elements/ButtonSettings.vue').default);
Vue.component('checklist-settings', require('@/components/composer/Elements/ChecklistSettings.vue').default);
Vue.component('faqs-settings', require('@/components/composer/Elements/FaqsSettings.vue').default);
Vue.component('find-location-map-settings', require('@/components/composer/Elements/FindLocationMapSettings.vue').default);
Vue.component('form-settings', require('@/components/composer/Elements/FormSettings.vue').default);
Vue.component('header-image', require('@/components/composer/Elements/HeaderImageSettings.vue').default);
Vue.component('homepage-header-settings', require('@/components/composer/Elements/HomepageHeaderSettings.vue').default);
Vue.component('html-settings', require('@/components/composer/Elements/HTMLSettings.vue').default);
Vue.component('image-settings', require('@/components/composer/Elements/ImageSettings.vue').default);
Vue.component('latest-posts-settings', require('@/components/composer/Elements/LatestPostSettings.vue').default);
Vue.component('location-details-settings', require('@/components/composer/Elements/LocationDetailsSettings.vue').default);
Vue.component('location-slider-settings', require('@/components/composer/Elements/LocationSliderSettings.vue').default);
Vue.component('news-settings', require('@/components/composer/Elements/NewsSettings.vue').default);
Vue.component('newsletter-settings', require('@/components/composer/Elements/NewsletterSettings.vue').default);
Vue.component('quick-book-settings', require('@/components/composer/Elements/QuickBookSettings.vue').default);
Vue.component('section-link-settings', require('@/components/composer/Elements/SectionLinkSettings.vue').default);
Vue.component('slider-settings', require('@/components/composer/Elements/SliderSettings.vue').default);
Vue.component('social-links-settings', require('@/components/composer/Elements/SocialLinkSettings.vue').default);
Vue.component('stay-in-touch-settings', require('@/components/composer/Elements/StayInTouchSettings.vue').default);
Vue.component('tab-settings', require('@/components/composer/Elements/TabSettings.vue').default);
Vue.component('testimonials-section-settings', require('@/components/composer/Elements/TestimonialsSectionSettings.vue').default);
Vue.component('testimonials-widget-settings', require('@/components/composer/Elements/TestimonialsWidgetSettings.vue').default);
Vue.component('text-settings', require('@/components/composer/Elements/TextSettings.vue').default);
Vue.component('title-settings', require('@/components/composer/Elements/TitleSettings.vue').default);
Vue.component('divider-settings', require('@/components/composer/Elements/DividerSettings.vue').default);
Vue.component('trust-pilot-settings', require('@/components/composer/Elements/TrustPilotSettings.vue').default);
Vue.component('google-reviews-settings', require('@/components/composer/Elements/GoogleReviewsSettings.vue').default);
Vue.component('servicing-quicklinks-settings', require('@/components/composer/Elements/ServicingQuicklinksSettings.vue').default);
Vue.component('cta-blocks-settings', require('@/components/composer/Elements/CtaBlocksSettings.vue').default);
Vue.component('homepage-header-blocks-settings', require('@/components/composer/Elements/HomepageHeaderBlocksSettings.vue').default);
Vue.component('header-list-settings', require('@/components/composer/Elements/HeaderListSettings.vue').default);
Vue.component('stay-in-touch-new-settings', require('@/components/composer/Elements/StayInTouchNewSettings.vue').default);
Vue.component('tyre-settings', require('@/components/composer/Elements/TyreSettings.vue').default);
Vue.component('contact-us-header-settings', require('@/components/composer/Elements/ContactUsHeaderSettings.vue').default);
Vue.component('contact-us-ctas-settings', require('@/components/composer/Elements/ContactUsCtasSettings.vue').default);
Vue.component('referral-form-settings', require('@/components/composer/Elements/ReferralFormSettings.vue').default);




// WEBPACK FOOTER //
// ./src/components.js